@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [class]="toast.classname"
    class="border border-dark"
    [autohide]="true"
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)">
    {{ toast.body }}
  </ngb-toast>
}
